export default __webpack_public_path__ + "locales/si/Notifications.json?hash=b3edf5fa0988a6c99458d84eb24863cd";